import React from 'react';
import ReactDOM from 'react-dom';
import { loadStripe } from '@stripe/stripe-js';
import PricingOptionComponent from './PricingOption';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

export default class PlanSelectorComponent extends React.Component{

  handleClick = (plan_stripe_id) => {
    var stripe = Stripe(this.props.stripe_api_key);

    fetch(`/dashboard/create-checkout-session/${plan_stripe_id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(session) {
      return stripe.redirectToCheckout({ sessionId: session.id });
    })
    .then(function(result) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, you should display the localized error message to your
      // customer using `error.message`.
      if (result.error) {
        alert(result.error.message);
      }
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }

  render() {
    const current_user    = this.props.current_user,
    current_subscription  = this.props.current_subscription,
    default_plan          = this.props.default_plan,
    isDefaultPlan         = !current_subscription,
    colorClasses          = ['green','blue','purple'];

    return (<div className="row text-center">
      {this.props.plans.map((plan, index) => {
        const arrIndex = index % 3;
        const colorClass = colorClasses[index % 3];
        return <PricingOptionComponent 
          key={plan.id}
          currentSubscription={current_subscription}
          onButtonClickEvent={this.handleClick}
          colorClass={colorClass}
          plan={plan} />;
        }
      )}
      <div className="col-12">
        <div className="alert alert-success" role="alert">
          Need something more powerful that Pro?&nbsp;
          <a 
            href={`mailto:contact@keenforms.com?subject=We need the enterprise plan ${this.props.current_user.email}&body=${this.props.current_user.email} would like to learn about the enterprise plan`}
            className="">Contact Us for Enterprise</a>
        </div>
      </div>
      <div className="col-lg-3 invisible">placeholder</div>
      <div className="col-lg-6">
        <div className={`card mb-4 shadow-sm ${isDefaultPlan ? 'active-plan' : ''}`}>
          <div className="card-header">
          <h4 className="font-weight-bold">{default_plan.name}</h4>
          </div>
          <div className="card-body">
            <ul className="list-unstyled">
              <li className="">
                <strong>{default_plan.keenform_limit}</strong> Keenforms with up to
              </li>
              <li>
                <strong>{default_plan.form_attribute_limit}</strong> attributes and <strong>{default_plan.form_rule_limit}</strong> rules
              </li>
              <li><strong>{default_plan.submissions_limit.toLocaleString()}</strong> Submissions per month</li>
            </ul>
            { isDefaultPlan
              ? <div className="alert alert-info" role="alert">This is your current plan</div>
              :  <a 
                  href={`mailto:contact@keenforms.com?subject=downgrade account for ${this.props.current_user.email}&body=Please downgrade account for ${this.props.current_user.email} to free plan`}
                  className="btn btn-outline-secondary">You can downgrade any time, but you need to email us</a>
            }
          </div>
        </div>
      </div>
    </div>);
  }
}